// import { useState, useEffect } from "react";
// import { NavLink } from "react-router-dom";
// import { FaBars, FaUsers, FaHandshake, FaWallet, FaAlgolia, FaUserFriends, FaUserTimes, FaHandHoldingUsd, FaVoteYea, FaRupeeSign, FaArrowAltCircleDown, FaGlobe, FaDiceD6, FaHandHoldingMedical,FaHands, FaHandsHelping   } from "react-icons/fa";
// import { AnimatePresence, motion } from "framer-motion";
// import SidebarMenu from "./SidebarMenu";

// const routes = [
//   {
//     path: "/Profile",
//     name: "Profile",
//     icon: <FaHandshake />,
//   },
//   {
//     path: "/Operation/Customer",
//     name: "Customer",
//     icon: <FaUsers />,
//   },
//   // {
//   //   path: "/Operation/CreditCheck",
//   //   name: "Credit Check",
//   //   icon: <FaCreditCard />,
//   // },
//   // {
//   //   path: "/Operation/KYC",
//   //   name: "Aadhar KYC",
//   //   icon: <FaUserShield />,
//   // },
//   // {
//   //   path: "/Operation/BankVerification",
//   //   name: "Bank Verification",
//   //   icon: <FaUserEdit />,
//   // },
//   // {
//   //   path: "/Operation/VerifiedCustomer",
//   //   name: "Verified Customer",
//   //   icon: <FaUserFriends />,
//   // },
//   {
//     path: "/loanmaster/Loan",
//     name: "Loan",
//     icon: <FaHandHoldingUsd />,
//   },
//   {
//     path: "/account/PendingDisbursement",
//     name: "Ready To Disbursed",
//     icon: <FaVoteYea />,
//   },
//   {
//     path: "/account/disbursement",
//     name: "Disbursment",
//     icon: <FaRupeeSign />,
//   },
//   {
//     path: "/loanmaster/Repayment",
//     name: "Repayment",
//     icon: <FaHandsHelping />,
//   },
//    {
//     path: "/Product",
//     name: "Product",
//     icon: <FaDiceD6 />,
//     subRoutes: [
//       {
//         path: "/loanmaster/AddProduct",
//         name: "AddProduct",  
//         icon: <FaHandHoldingMedical />,
//       },
//       {
//         path: "/loanmaster/Product",
//         name: "Product",
//         icon: <FaHands />,
//       },
//     ],
//   },
//   {
//     path: "/Reports",
//     name: "Reports",
//     icon: <FaGlobe />,
//     subRoutes: [
//       {
//         path: "/Excel/ReportsDashboard",
//         name: "ReportsDashboard",
//         icon: <FaArrowAltCircleDown />,
//       },
//       {
//         path: "/Excel/Collection",
//         name: "Collection",
//         icon: <FaArrowAltCircleDown />,
//       },
//       {
//         path: "/Excel/Disbursed",
//         name: "Disbursed",
//         icon: <FaArrowAltCircleDown />,
//       },
//       {
//         path: "/Excel/MasterSheet",
//         name: "Master Sheet",
//         icon: <FaArrowAltCircleDown />,
//       },
//     ],
//   },
//   {
//     path: "/TodayRepayment",
//     name: "Today Repayment",
//     icon: <FaWallet />,
//   },
//   {
//     path: "/OverDue",
//     name: "Over Due",
//     icon: <FaAlgolia />,
//   },
//   {
//     path: "/employee/AllEmployee",
//     name: "All Employee",
//     icon: <FaUserFriends />,
//   },
//   {
//     path: "/operation/Reject",
//     name: "Reject",
//     icon: <FaUserTimes />,
//   },
// ];

// const Sidebar = ({ children }) => {
//   const [isOpen, setIsOpen] = useState(true);

//   // Set sidebar closed by default on mobile view
//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth <= 768) {
//         setIsOpen(false);
//       } else {
//         setIsOpen(true);
//       }
//     };

//     handleResize(); // Set initial state based on screen size
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const toggle = () => setIsOpen(!isOpen);

//   const showAnimation = {
//     hidden: {
//       width: 0,
//       opacity: 0,
//       transition: {
//         duration: 0.5,
//       },
//     },
//     show: {
//       opacity: 1,
//       width: "auto",
//       transition: {
//         duration: 0.5,
//       },
//     },
//   };

//   return (
//     <div className="main-container">
//       <motion.div
//         animate={{
//           width: isOpen ? "215px" : "45px",
//           transition: {
//             duration: 0.5,
//             type: "spring",
//             damping: 10,
//           },
//         }}
//         className="sidebar"
//       >
//         <div className="top_section">
//           <AnimatePresence>
//             {isOpen && (
//               <motion.h1
//                 variants={showAnimation}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//                 className="logo"
//               >
//                 <strong>
//                   <NavLink to="/Dashboard">Dashboard</NavLink>
//                 </strong>
//               </motion.h1>
//             )}
//           </AnimatePresence>

//           <div className="bars">
//             <FaBars onClick={toggle} />
//           </div>
//         </div>

//         <section className="routes">
//           {routes.map((route, index) => {
//             if (route.subRoutes) {
//               return (
//                 <SidebarMenu
//                   setIsOpen={setIsOpen}
//                   route={route}
//                   showAnimation={showAnimation}
//                   isOpen={isOpen}
//                   key={index}
//                 />
//               );
//             }

//             return (
//               <NavLink
//                 to={route.path}
//                 key={index}
//                 className="link"
//                 activeClassName="active"
//               >
//                 <div className="icon">{route.icon}</div>
//                 <AnimatePresence>
//                   {isOpen && (
//                     <motion.div
//                       variants={showAnimation}
//                       initial="hidden"
//                       animate="show"
//                       exit="hidden"
//                       className="link_text"
//                     >
//                       {route.name}
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </NavLink>
//             );
//           })}
//         </section>
//       </motion.div>

//       <main>{children}</main>
//     </div>
//   );
// };

// export default Sidebar;

import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  FaBars, FaUsers, FaHandshake, FaWallet, FaAlgolia,
  FaUserFriends, FaUserTimes, FaHandHoldingUsd, FaVoteYea,
  FaRupeeSign, FaArrowAltCircleDown, FaArrowAltCircleUp, FaGlobe, FaDiceD6,
  FaHandHoldingMedical, FaHands, FaHandsHelping, FaSyncAlt
} from "react-icons/fa";
import { AnimatePresence, motion } from "framer-motion";
import SidebarMenu from "./SidebarMenu";
import base_url from "../config/Config";
import Cookies from "js-cookie";

const allRoutes = [
  { path: "/Profile", name: "Profile", icon: <FaHandshake /> },
  { path: "/Operation/Customer", name: "Customer", icon: <FaUsers /> },
  { path: "/loanmaster/Loan", name: "Loan", icon: <FaHandHoldingUsd /> },
  { path: "/loanmaster/MultipleLoans", name: "Multiple Loans", icon: <FaHandHoldingUsd /> },
  { path: "/account/PendingDisbursement", name: "Ready To Disbursed", icon: <FaVoteYea /> },
  { path: "/account/disbursement", name: "Disbursement", icon: <FaRupeeSign /> },
  { path: "/loanmaster/Repayment", name: "Repayment", icon: <FaHandsHelping /> },
  {
    path: "/Product",
    name: "Product",
    icon: <FaDiceD6 />,
    subRoutes: [
      { path: "/loanmaster/AddProduct", name: "Addproduct", icon: <FaHandHoldingMedical /> },
      { path: "/loanmaster/Product", name: "Product", icon: <FaHands /> },
    ],
  },
  {
    path: "/Reports",
    name: "Reports",
    icon: <FaGlobe />,
    subRoutes: [
      { path: "/Excel/ReportsDashboard", name: "Reports Dashboard", icon: <FaArrowAltCircleDown /> },
      { path: "/Excel/Collection", name: "Collection", icon: <FaArrowAltCircleDown /> },
      { path: "/Excel/Disbursed", name: "Disbursed", icon: <FaArrowAltCircleDown /> },
      { path: "/Excel/MasterSheet", name: "Mastersheet", icon: <FaArrowAltCircleDown /> },
      { path: "/Excel/LoanDeactivate", name: "LoanDeactivate", icon: <FaArrowAltCircleDown /> },
       { path: "/Excel/EmiUpload", name: "Upload Paid Sheet", icon: <FaArrowAltCircleUp /> },
    ],
  },
  { path: "/TodayRepayment", name: "Today Repayment", icon: <FaWallet /> },
  { path: "/OverDue", name: "Overdue", icon: <FaAlgolia /> },
  {
    path: "/AutoDebitMandates",
    name: "Auto Debit Mandate",
    icon: <FaSyncAlt />,
    subRoutes: [
      { path: "/AutoDebitMandates?tab=all", name: "All Mandates", icon: <FaArrowAltCircleDown /> },
      { path: "/AutoDebitMandates?tab=pending", name: "Pending", icon: <FaArrowAltCircleDown /> },
      { path: "/AutoDebitMandates?tab=success", name: "Success", icon: <FaArrowAltCircleDown /> },
      { path: "/AutoDebitMandates?tab=failed", name: "Failed", icon: <FaArrowAltCircleDown /> },
    ],
  },
  { path: "/employee/AllEmployee", name: "All Eployee", icon: <FaUserFriends /> },
  { path: "/operation/Reject", name: "Reject", icon: <FaUserTimes /> },
];

const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [permissions, setPermissions] = useState([]);

  // 🔹 Handle responsive
  useEffect(() => {
    const handleResize = () => setIsOpen(window.innerWidth > 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch permissions - sessionStorage cache se, API sirf ek baar
  useEffect(() => {
    const cached = sessionStorage.getItem("sidebarPermissions");
    if (cached) {
      setPermissions(JSON.parse(cached));
      return;
    }

    const token = Cookies.get("authToken");
    const role = localStorage.getItem("adminId") || "";
    if (!token) return;

    fetch(`${base_url}/api/auth/tabs/${role.toLowerCase()}`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch permissions");
        return res.json();
      })
      .then((data) => {
        sessionStorage.setItem("sidebarPermissions", JSON.stringify(data));
        setPermissions(data);
      })
      .catch((err) => console.error("Error fetching permissions:", err));
  }, []);

  // 🔹 Filter routes according to API
  const filteredRoutes = allRoutes.filter((route) =>
    permissions.some(
      (p) => p.tabName.toLowerCase() === route.name.toLowerCase() && p.canView
    )
  );

  const toggle = () => setIsOpen(!isOpen);

  const showAnimation = {
    hidden: { width: 0, opacity: 0, transition: { duration: 0.5 } },
    show: { opacity: 1, width: "auto", transition: { duration: 0.5 } },
  };

  return (
    <div className="main-container">
      <motion.div
        animate={{
          width: isOpen ? "220px" : "52px",
          transition: { duration: 0.4, type: "spring", damping: 14 },
        }}
        className="sidebar"
      >
        {/* Brand header */}
        <div className="sidebar-brand">
          <AnimatePresence>
            {isOpen ? (
              <motion.div
                variants={showAnimation}
                initial="hidden"
                animate="show"
                exit="hidden"
                className="sidebar-brand-text"
              >
                <span className="brand-initials">US</span>
                <span className="brand-name">LMS Portal</span>
              </motion.div>
            ) : (
              <div className="brand-icon-only">US</div>
            )}
          </AnimatePresence>
          <div className="bars" onClick={toggle} title={isOpen ? 'Collapse' : 'Expand'}>
            <FaBars />
          </div>
        </div>

        {/* Nav links */}
        <section className="routes">
          {filteredRoutes.map((route, index) =>
            route.subRoutes ? (
              <SidebarMenu
                setIsOpen={setIsOpen}
                route={route}
                showAnimation={showAnimation}
                isOpen={isOpen}
                key={index}
              />
            ) : (
              <NavLink
                to={route.path}
                key={index}
                className="link"
                activeClassName="active"
                title={!isOpen ? route.name : ''}
              >
                <div className="icon">{route.icon}</div>
                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      variants={showAnimation}
                      initial="hidden"
                      animate="show"
                      exit="hidden"
                      className="link_text"
                    >
                      {route.name}
                    </motion.div>
                  )}
                </AnimatePresence>
              </NavLink>
            )
          )}
        </section>

        {/* Bottom user badge */}
        <AnimatePresence>
          {isOpen && (
            <motion.div
              variants={showAnimation}
              initial="hidden"
              animate="show"
              exit="hidden"
              className="sidebar-footer"
            >
              <div className="sf-avatar">A</div>
              <div className="sf-info">
                <span className="sf-name">Admin</span>
                <span className="sf-role">Super Admin</span>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>

      <main>{children}</main>
    </div>
  );
};

export default Sidebar;
